import Form                  from '@widesk-ui/components/form/Form';
import Input                 from '@widesk-ui/components/form/Input';
import { useAuth }           from '@widesk-ui/hooks/useAuth';
import View                  from '@widesk-ui/components/View';
import Text                  from '@widesk-ui/components/Text';
import Button                from '@widesk-ui/components/Button';
import Link                  from '@widesk-ui/components/Link';
import InputPassword         from '@widesk-ui/components/form/InputPassword';
import useDidMount           from '@widesk-core/hooks/useDidMount';
import AuthCardLayout        from '@/components/AuthCardLayout';
import Logo                  from '@/components/Logo';
import React                 from 'react';
import { CloseCircleFilled } from '@ant-design/icons';

const loginErrorMessage = (err: unknown) => {
	const error = err as { connectorError?: { response?: { status?: number } }; response?: { status?: number } };
	const status = error?.connectorError?.response?.status ?? error?.response?.status;

	return status === 401
		? 'Identifiant ou mot de passe incorrect.'
		: 'Connexion impossible pour le moment. Réessayez dans un instant.';
};

export default function LoginPage() {
	const { login } = useAuth();
	const [error, setError] = React.useState<string>();

	useDidMount(() => document.title = 'Authentification');

	return (
		<AuthCardLayout>
			<View row={false} center marginB={18}>
				<Logo short style={{ width: 44, height: 44, marginBottom: 14 }} />
				<Text uppercase size={13} color="var(--ant-color-primary)" style={{ letterSpacing: '.18em', fontFamily: 'monospace', marginBottom: 6 }}>
					tokamap · éditeur
				</Text>
				<Text size={14} color="var(--ant-color-text-description)">
					Connexion à l'espace de cartographie
				</Text>
			</View>

			<Form
				gap={16}
				hideLoadingTip
				fields={{
					username: {
						span: 24,
						label: 'Identifiant',
						element: <Input id="username" placeholder="ex. j.dupont" size="large" autoComplete="username" />,
						required: true,
					},
					password: {
						span: 24,
						label: 'Mot de passe',
						element: <InputPassword id="password" placeholder="••••••••" size="large" autoComplete="current-password" />,
						required: true,
					},
				}}
				onChange={() => setError(undefined)}
				onSubmit={async ({ username, password }) => {
					try {
						await login(username as string, password as string);
					} catch (err) {
						setError(loginErrorMessage(err));

						return false;
					}
				}}
			>
				{!!error && (
					<div role="alert" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--ant-color-error)', fontSize: 14 }}>
						<CloseCircleFilled />
						{error}
					</div>
				)}

				<Button size="large" block type="primary" htmlType="submit" style={{ marginTop: 8, height: 48, fontSize: 16 }}>
					Ouvrir l'éditeur
				</Button>
			</Form>

			<View marginT={16} center>
				<Link linkSecondary to="/reset_password">Mot de passe oublié</Link>
			</View>
		</AuthCardLayout>
	);
}
